export default __webpack_public_path__ + "static/media/ic_botswana.060448dd.svg";